import { createReducer, on } from '@ngrx/store';
import { changeQueryInput } from '../search-all-params/search-all-params.actions';
export const queryInput = createReducer('', on(changeQueryInput, (state, action) => {
    return action.queryInput;
}));
